import Dialog from "@mui/material/Dialog";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Document, Image, Page, pdf, PDFViewer, StyleSheet, Text, View } from "@react-pdf/renderer";
import GetAppIcon from "@mui/icons-material/GetApp";

import { useCompanyAssigned } from "../../CompanyAssignedContext";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCodeColor } from '../../../components'
/**
 * Convierte "dd/mm/yyyy" a objeto Date de JavaScript
 */
function parseDDMMYYYY(dateStr) {
	// dateStr = "01/01/2025", por ejemplo
	const [day, month, year] = dateStr.split("/");
	return new Date(+year, +month - 1, +day);
}

/**
 * Convierte "yyyy-mm-dd" a objeto Date de JavaScript
 */
function parseYYYYMMDD(dateStr) {
	// dateStr = "2025-03-13", por ejemplo
	const [year, month, day] = dateStr.split("-");
	return new Date(+year, +month - 1, +day);
}

function getMonthDayDifference(startDate, endDate) {
	// Año/mes/día de inicio
	const startYear = startDate.getFullYear();
	const startMonth = startDate.getMonth(); // 0-11
	const startDay = startDate.getDate();

	// Año/mes/día final
	const endYear = endDate.getFullYear();
	const endMonth = endDate.getMonth();
	const endDay = endDate.getDate();

	// Calculamos la diferencia en meses totales
	// (Año * 12 + mes) para pasar todo a "meses absolutos"
	let monthDiff = endYear * 12 + endMonth - (startYear * 12 + startMonth);
	// Diferencia de días
	let dayDiff = endDay - startDay;

	// Si dayDiff < 0, significa que hay que "prestar" un mes
	if (dayDiff < 0) {
		monthDiff -= 1;
		// Averiguamos cuántos días tuvo el mes anterior a endDate
		let prevMonth = endMonth - 1;
		let prevYear = endYear;
		if (prevMonth < 0) {
			prevMonth = 11;
			prevYear -= 1;
		}
		// Cantidad de días en el mes anterior
		const daysInPrevMonth = new Date(prevYear, prevMonth + 1, 0).getDate();
		// Ajustamos dayDiff sumándole la cantidad de días del mes anterior
		dayDiff = daysInPrevMonth + dayDiff;
	}

	// Armamos un texto
	let result = "";
	if (monthDiff > 0) {
		result += monthDiff + (monthDiff === 1 ? " mes" : " meses");
	}
	if (monthDiff > 0 && dayDiff > 0) {
		result += " y ";
	}
	if (dayDiff > 0) {
		result += dayDiff + (dayDiff === 1 ? " día" : " días");
	}

	// Si no hay ni meses ni días
	if (!result) result = "0 días";

	return result;
}

export const GeneratePdfOrdenVenta = ({ apiResponse, isOpen, onClose, themeColor, convertPrice = (() => { }) }) => {
	const themeConverted = getCodeColor(themeColor);

	if (!apiResponse || Object.entries(apiResponse).length === 0) {
		return null;
	}

	const handleDownloadPdf = async () => {
		if (!apiResponse || Object.entries(apiResponse).length === 0) {
			return null;
		}

		try {
			// Generate the PDF
			const asPdf = pdf(<SaleOrderPdf saleData={apiResponse} themeColor={themeConverted} convertPrice={convertPrice}/>);
			const blob = await asPdf.toBlob();

			// Create a download link
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;

			// Set custom filename with order number and client name
			link.download = `OrdenVenta_${apiResponse.client}.pdf`;

			// Trigger download
			link.click();

			// Clean up
			URL.revokeObjectURL(fileURL);
		} catch (error) {
			console.error("Error generating PDF:", error);
		}
	};

	return (
		<Dialog fullScreen open={isOpen}>
			<AppBar sx={{ position: "relative" }}>
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
						<CloseIcon />
					</IconButton>
					<Button color="inherit" startIcon={<GetAppIcon />} onClick={handleDownloadPdf} sx={{ ml: "auto" }}>
						Descargar PDF
					</Button>
				</Toolbar>
			</AppBar>
			<PDFViewer width="100%" height="100%">
				<SaleOrderPdf saleData={apiResponse} themeColor={themeConverted} convertPrice={convertPrice} />
			</PDFViewer>
		</Dialog>
	);
};

const SaleOrderPdf = ({ saleData, themeColor, convertPrice = (() => { }) }) => {
	const [color, setColor] = useState("");
	useEffect(() => {
		if (themeColor) {
			setColor(themeColor);
		}
	}, [themeColor, saleData]);

	const styles = StyleSheet.create({
		page: {
			flexDirection: "column",
			padding: 10,
			fontSize: 10,
			fontFamily: "Helvetica",
			position: "relative",
			bottom: "30",
		},
		headerContainer: {
			flexDirection: "row",
			alignContent: "center",
			paddingBottom: 10,
		},
		headerLeft: {
			flexDirection: "column",
			width: "40%",
			lineHeight: 1.2,
			fontSize: 7,
		},
		logo: {
			width: 150,
			height: 100,
		},
		titleBig: {
			fontFamily: "Helvetica-Bold",
			fontSize: 19,
			letterSpacing: 1,
			margin: 0,
			paddingLeft: 35,
			position: "relative",
			top: "15",
			right: "60",
		},
		titleNumber: {
			fontSize: 18,
			color: "#ff3d3d",
			fontWeight: "bold",
			paddingLeft: 70,
			letterSpacing: 2,
			fontFamily: "Helvetica-Bold",
			position: "relative",
			right: 10,
		},
		subHeaderContainer: {
			flexDirection: "row",
			justifyContent: "space-between",
			paddingRight: "10",
			alignItems: "center",
			position: "relative",
			bottom: 12,
			fontSize: 9,
		},
		tableContainer: {
			width: "100%",
			marginVertical: 10,
			position: "relative",
			bottom: 28,
		},
		tableHeader: {
			flexDirection: "row",
			backgroundColor: themeColor,
			color: "#fff",
			fontWeight: "bold",
		},
		tableHeaderCell: {
			padding: 5,
			textAlign: "center",
			fontWeight: "bold",
			fontSize: 8,
		},
		tableRow: {
			flexDirection: "row",
		},
		tableCell: {
			padding: 5,
			textAlign: "center",
			fontSize: 8,
		},
		tableCellCodigo: { flex: 1.5 },
		tableCellDescripcion: { flex: 4, textAlign: "left" },
		tableCellCantidad: { flex: 1 },
		tableCellPrecioUnitario: { flex: 1.4 },
		tableCellDescuento: { flex: 1.2 },
		tableCellPrecio: { flex: 1.2 },
		bottomRowContainer: {
			flexDirection: "row",
			alignItems: "center",
			borderTop: "1px solid #000",
			marginTop: 5,
		},
		bottomNoteContainer: {
			flex: 3,
			position: "relative",
		},
		bottomNote: {
			backgroundColor: themeColor,
			color: "#fff",
			fontSize: 11,
			fontWeight: "bold",
			paddingVertical: 15,
			paddingHorizontal: 10,
			textAlign: "center",
		},
		bottomTotals: {
			flex: 2,
			padding: 5,
			fontSize: 10,
			lineHeight: 1.5,
		},
		bottomTotalsItem: {
			flexDirection: "row",
			justifyContent: "space-between",
		},
		boldText: {
			fontWeight: "bold",
		},
		bottomDetailsRow: {
			flexDirection: "row",
			justifyContent: "space-between",
			fontSize: 10,
		},
		bottomDetailsText: {
			textAlign: "left",
			fontSize: 10,
		},
		signatureContainer: {
			marginTop: 0,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-around",
			position: "relative",
			bottom: 5,
		},
		signatureLine: {
			marginBottom: 5,
		},
		signatureBox: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		warrantyContainer: {
			flexDirection: "row",
			borderTop: "1px solid #000",
			paddingTop: 0,
			alignItems: "flex-start",
			justifyContent: "flex-end",
			position: "relative",
			bottom: "30",
		},
		warrantyBox: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			width: "75%",
			backgroundColor: themeColor,
			color: "#fff",
			padding: 5,
			paddingTop: 1,
			paddingBottom: 1,
			fontSize: 10,
			marginRight: 10,
			position: "relative",
			bottom: 7,
		},
		warrantyTitle: {
			fontWeight: "bold",
			textTransform: "uppercase",
			marginRight: 20,
			fontSize: 7,
			position: "relative",
			left: 10,
		},
		warrantyItem: {
			flexDirection: "row",
			marginBottom: 3,
			lineHeight: 0.8,
			fontSize: 6,
		},
		totalBox: {
			width: "25%",
			fontSize: 8,
			position: "relative",
			top: 2,
			lineHeight: 1,
		},
		totalRow: {
			flexDirection: "row",
			justifyContent: "space-between",
			marginBottom: 5,
		},
		totalValue: {
			fontWeight: "bold",
		},
		pageNumbers: {
			position: "absolute",
			bottom: 20,
			right: 20,
			textAlign: "right",
		},
	});

	if (!saleData) {
		// Si no hay data, devolvemos un documento simple que diga "Cargando..."
		return (
			<Document>
				<Page size="A4" style={styles.page}>
					<Text>Cargando datos de la orden de venta...</Text>
				</Page>
			</Document>
		);
	}
	// Extraemos datos principales
	const {
		cName,
		cNit,
		address,
		phone,
		nro,
		oDate,
		oTime,
		client,
		seller,
		seller_phone,
		total,
		delivery,
		details,
		warranty,
		client_phone,
	} = saleData;

	// Calculamos el total + delivery si lo hubiera
	const subTotal = parseFloat(total || 0);
	const deliveryFee = parseFloat(delivery || 0);
	const grandTotal = subTotal + deliveryFee;

	// 1) Parsear fecha de la venta (oDate) en Date
	const saleDate = parseDDMMYYYY(oDate); // "dd/mm/yyyy" -> Date()
	// 2) Parsear fecha de la garantía (warranty) en Date
	const warrantyDate = parseYYYYMMDD(warranty); // "yyyy-mm-dd" -> Date()

	// 3) Calcular la diferencia
	let warrantyDifference = "";
	if (warrantyDate < saleDate) {
		warrantyDifference = "0 días";
	} else {
		warrantyDifference = getMonthDayDifference(saleDate, warrantyDate);
	}
	const API_url = process.env.REACT_APP_API_URL;

	const calcPrecioTotal = (precio = 0, descuento = 0, cantidad) => {
		const total = (parseFloat(precio) - parseFloat(descuento)) * parseInt(cantidad);

		return total.toFixed(2);
	}

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				{/* Encabezado */}
				<View style={styles.headerContainer}>
					<View style={styles.headerLeft}>
						<View style={{ position: "relative", top: 7 }}>
							<Image
								source={`${API_url}${saleData.logo}`}
								src={`${API_url}${saleData.logo}`}
								style={styles.logo}
							/>
						</View>
						<View>
							<Text>Empresa: {cName} </Text>
							<Text>Dirección: {address}</Text>
							<View style={{ flexDirection: "row", marginTop: "2px" }}>
								<Text>NIT: {cNit}</Text>
								{/* <Text style={{ paddingLeft: 15 }}>Tel: {phone}</Text> */}
							</View>
						</View>
					</View>
					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleBig}>ORDEN DE VENTA</Text>
					</View>
					<View style={{ justifyContent: "center", alignItems: "center" }}>
						<Text style={styles.titleNumber}>N°{nro}</Text>
					</View>
				</View>

				{/* Sub-encabezado */}
				<View style={styles.subHeaderContainer}>
					<Text>
						Cliente: {client} Tel: {client_phone}
					</Text>
					<View
						style={{
							display: "flex",
							flexDirection: "column",
							gap: 2,
							position: "relative",
							bottom: 10,
						}}>
						<View
							style={{
								display: "flex",
								flexDirection: "row",
								gap: 5,
								position: "relative",
								bottom: 0,
							}}>
							<Text>Fecha: {oDate}</Text>
							<Text style={{ fontSize: 7, position: "relative", top: "1.5" }}>{oTime}</Text>
						</View>

						<Text>Garantía: {warrantyDifference}</Text>
					</View>
				</View>

				{/* Tabla de detalles */}
				<View style={styles.tableContainer}>
					<View style={styles.tableHeader}>
						<Text style={[styles.tableHeaderCell, styles.tableCellCodigo]}>Código</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDescripcion]}>Descripción</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellCantidad]}>Cantidad</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPrecioUnitario]}>Precio Unitario</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellDescuento]}>Descuento</Text>
						<Text style={[styles.tableHeaderCell, styles.tableCellPrecio]}>Precio</Text>
					</View>
					{details && details.length > 0 ? (
						details.map((item, index) => {
							const precioUnitario = parseFloat(item.priceR || 0) + parseFloat(item.priceB);
							const descuento = parseFloat(item.discount_price || 0);
							const precioTotal = calcPrecioTotal(precioUnitario, descuento, item.qp);

							return (
								<View style={styles.tableRow} key={index}>
									<Text style={[styles.tableCell, styles.tableCellCodigo]}>{item.code}</Text>
									<Text style={[styles.tableCell, styles.tableCellDescripcion]}>
										{item.description}
									</Text>
									<Text style={[styles.tableCell, styles.tableCellCantidad]}>{item.qp}</Text>
									<Text style={[styles.tableCell, styles.tableCellPrecioUnitario]}>
										{convertPrice(precioUnitario, null, true)}
									</Text>
									<Text style={[styles.tableCell, styles.tableCellDescuento]}>
										{convertPrice(descuento, null, true)}
									</Text>
									<Text style={[styles.tableCell, styles.tableCellPrecio]}>
										{convertPrice(precioTotal, null, true)}
									</Text>
								</View>
							);
						})
					) : (
						<View style={styles.tableRow}>
							<Text style={[styles.tableCell, { flex: 1 }]}>Sin detalles</Text>
						</View>
					)}
				</View>

				{/* Sección de totales y garantía */}
				<View style={[styles.warrantyContainer, styles.bottomRowContainer]}>
					<View style={styles.warrantyBox}>
						<View>
							<Text style={styles.warrantyTitle}>GARANTÍA</Text>
						</View>
						<View>
							<Text style={styles.warrantyItem}>
								a) Garantía real 15 días de la fecha entregada (daños de fábrica).
							</Text>
							<Text style={styles.warrantyItem}>
								b) La empresa cubrirá la garantía parcial o total del producto con la presente nota.
							</Text>
							<Text style={styles.warrantyItem}>
								c) La empresa no cubrirá la garantía por uso inadecuado, malas instalaciones eléctricas,
								etc.
							</Text>
						</View>
					</View>
					<View style={styles.totalBox}>
						<View style={styles.totalRow}>
							<Text>Subtotal:</Text>
							<Text style={styles.totalValue}>{convertPrice(subTotal)}</Text>
						</View>
						<View style={styles.totalRow}>
							<Text>Delivery:</Text>
							<Text style={styles.totalValue}>{convertPrice(deliveryFee)}</Text>
						</View>
						<View style={styles.totalRow}>
							<Text>Total a pagar:</Text>
							<Text style={styles.totalValue}>{convertPrice(grandTotal)}</Text>
						</View>
					</View>
				</View>

				{/* Firmas */}
				<View style={styles.signatureContainer}>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>{seller}</Text>
						<Text>Vendedor</Text>
					</View>
					<View style={styles.signatureBox}>
						<Text style={styles.signatureLine}>___________________________</Text>
						<Text>Cliente</Text>
					</View>
				</View>
				<Text
					style={styles.pageNumbers}
					render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
					fixed
				/>
			</Page>
		</Document>
	);
};
